export const SUPPORTED_LANGUAGES = [
  {
    langCode: 'en',
    flagCode: 'GB',
  },
  {
    langCode: 'de',
    flagCode: 'DE',
  },
];
